import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import VolumeOff from '@mui/icons-material/VolumeOff';
import VolumeUp from '@mui/icons-material/VolumeUp';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

import { secondsToMinutesAndSeconds } from 'services/helpers/formatTime';

export const getPlayPauseIcon = (
  isPlaying: boolean,
): OverridableComponent<SvgIconTypeMap<object, 'svg'>> => (isPlaying ? PauseIcon : PlayArrowIcon);

export const getOnPlayPauseClick = (
  isPlaying: boolean,
  handlePause: () => void,
  handlePlay: () => void,
): (() => void) => (isPlaying ? handlePause : handlePlay);

export const getMuteIcon = (
  isMuted: boolean,
  currentVolume: number,
): OverridableComponent<SvgIconTypeMap<object, 'svg'>> =>
  isMuted || currentVolume === 0 ? VolumeOff : VolumeUp;

export const getFullscreenButtonIcon = (
  isFullscreen: boolean,
): OverridableComponent<SvgIconTypeMap<object, 'svg'>> =>
  isFullscreen ? FullscreenExitIcon : FullscreenIcon;

export const getElapsedAndTotalTime = (
  songCurrentTime: number | null,
  songDuration: number | null,
): string => {
  if (songCurrentTime === null || songDuration === null) return '- / -';
  return `${secondsToMinutesAndSeconds(songCurrentTime, true)} / ${secondsToMinutesAndSeconds(
    songDuration,
    true,
  )}`;
};

export const getBufferedTimeRangesArray = (
  timeRanges: TimeRanges | null,
): { start: number; end: number }[] => {
  if (!timeRanges) {
    return [];
  }

  const bufferedTimeRangesArray = [];
  for (let rangeIndex = 0; rangeIndex < timeRanges.length; rangeIndex++) {
    bufferedTimeRangesArray.push({
      start: timeRanges.start(rangeIndex),
      end: timeRanges.end(rangeIndex),
    });
  }
  return bufferedTimeRangesArray;
};
